<template>
    <div class="columns is-full-screen-height is-mobile is-8" :class="theme">
        <div
            v-if="$slots['sidebar']"
            v-show="show_sidebar"
            class="column sidebar is-narrow hide-on-print is-paddingless">

            <slot name="sidebar"></slot>
        </div>

        <div
            v-if="$slots['middle-sidebar']"
            v-show="show_middle_sidebar"
            class="column middle-sidebar has-background-light
            is-narrow is-paddingless hide-on-print">

            <slot name="middle-sidebar"></slot>
        </div>


        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BaseLayout',
    props: {
        theme: { type: String, default: 'dark' },
        show_sidebar: { type: Boolean, default: true },
        show_middle_sidebar: { type: Boolean, default: true },
    },
    inject: ['$validator'],
};
</script>
